import { call, put, select } from "redux-saga/effects";

import { deleteUserAvatar, uploadUserAvatar } from "../../api/avatar/requests";
import { consoleLogError } from "../../utils/console";
import { _sharedActionsSystem } from "../system/actions";
import { selectorSystemIsLogin } from "./selectors";
import { _sharedActionsSupport } from "./actions";

const scope = "Shared System";

function* _renewUserAvatarLastUpdateTimestamp() {
  yield put(_sharedActionsSystem.setAvatarLastUpdateTimestamp(Date.now()));
}

export function* _sharedWorkerUploadAvatar(action) {
  try {
    const isLogin = yield select(selectorSystemIsLogin);
    if (isLogin) {
      const avatarFile = action.data;
      yield call(uploadUserAvatar, avatarFile);
      yield call(_renewUserAvatarLastUpdateTimestamp);
    }
  } catch (error) {
    consoleLogError(scope, "Error: ", error);
  }
}

export function* _sharedWorkerDeleteAvatar() {
  try {
    const isLogin = yield select(selectorSystemIsLogin);
    if (isLogin) {
      yield call(deleteUserAvatar);
      yield call(_renewUserAvatarLastUpdateTimestamp);
    }
  } catch (error) {
    consoleLogError(scope, "Error: ", error);
  }
}
